<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { useModelWrapper } from '../wrappers/helpers/useModelWrapper'

const { t } = useI18n({ useScope: 'global' })

const props = defineProps<{
  groupHeading: string
  isCollapsed: boolean
  rowsLength: number
  columnLength: number
}>()

const emit = defineEmits<{
  (e: 'update:isCollapsed', isCollapsed: boolean): void
}>()

const isCollapsed = useModelWrapper(props, emit, 'isCollapsed')

const toggleCollapsed = () => {
  isCollapsed.value = !isCollapsed.value
}
</script>
<template>
  <tr
    class="bg-grey-1 text-grey-9 cursor-pointer table-header"
    @click="toggleCollapsed"
    data-test="group-heading"
  >
    <td class="sticky-table-header cursor-pointer group-heading no-border row-number--header"></td>
    <td
      align="left"
      :colspan="columnLength"
      class="cursor-pointer q-mt-sm sticky-table-header group-heading sticky--left cursor-pointer"
    >
      <span class="text-h6 text-weight-regular">{{ groupHeading }}</span>
      <span class="text-caption text-grey-7">{{
        ` ${rowsLength} ${t('data.item', rowsLength)}`
      }}</span>
    </td>
    <td class="sticky-table-header cursor-pointer" v-if="$slots.itemRight"></td>
  </tr>
</template>
